module.exports = __webpack_public_path__ + "media/components/breakheader/static/icon--s5-061e04d593cb827e4cbd3239def4cd5c.svg";